import React, { useEffect } from 'react';

import BannerSlider from './BannerSlider/BannerSlider';

import { useRecoilState } from 'recoil';
import { isClientWidthState } from '../../../store/atoms';

import styled, { keyframes } from 'styled-components';
export default function Banner() {
  const [isClientWidth, setIsClientWidth] = useRecoilState(isClientWidthState);

  const getClientWidth = () => {
    const { clientWidth } = document.documentElement;
    return clientWidth;
  };

  const handleWidthSize = () => {
    setIsClientWidth(getClientWidth());
  };

  const getAutoPlaySpeed = () => {
    if (getClientWidth() > 750 && isClientWidth >= 0) {
      return 6000;
    }

    return 3000;
  };

  useEffect(() => {
    window.addEventListener('resize', handleWidthSize);

    return () => {
      window.addEventListener('resize', handleWidthSize);
    };
  }, []);

  return (
    <StyledBanner>
      <BannerSlider getAutoPlaySpeed={getAutoPlaySpeed} />
      <StyledContentsContainer>
        <StyledAboutTitle>
          투자자를 우선으로 생각하는 <br />
          알고리즘 투자 서비스를 만듭니다.
        </StyledAboutTitle>
        <StyledAboutDescription>
          기계와 돈을 다루기 위해 모였지만 우리의 모든 중심에는 사람이 있습니다.
          <br />
          우리는 알고리즘 투자를 통해 누구나 경제적 자유를 달성할 수 있다고
          믿습니다.
        </StyledAboutDescription>
        <StyledScrollAnimaion>
          <StyledScrollBorder>
            <StyledScrollCircle />
          </StyledScrollBorder>
          <StyledScrollText>scroll</StyledScrollText>
        </StyledScrollAnimaion>
      </StyledContentsContainer>
    </StyledBanner>
  );
}
const handleScrollAnimation = keyframes`
  0% {
    top: 20%
  }
  100% {
    top: 80%;
    opacity: 0;
  }
 
`;
const StyledBanner = styled.article`
  position: relative;
`;

const StyledContentsContainer = styled.div`
  max-width: 1280px;
  padding-top: 210px;
  position: absolute;
  top: 0;
  left: 18%;
  ${({ theme }) => theme.mobile`
  ${({ theme }) => theme.posCenterXY()};
    text-align: center;
    padding-top: 80px;
    width: 80%;
    top: 45%;
  `}
  z-index: 0;
`;

const StyledAboutTitle = styled.h1`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.pureWhite};
  font-size: 30px;
  font-weight: 700;
`;

const StyledAboutDescription = styled.h2`
  margin-bottom: 68px;
  color: ${({ theme }) => theme.colors.pureWhite};
  ${({ theme }) => theme.mobile`
    font-size: ${({ theme }) => theme.pixelToRem(14)};
  `}
`;

const StyledScrollAnimaion = styled.div`
  ${({ theme }) => theme.flex('column', 'center', 'flex-start')};

  ${({ theme }) => theme.mobile`
  ${({ theme }) => theme.flex('column')};
  `};
`;

const StyledScrollBorder = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  position: relative;
  width: 38px;
  height: 68px;
  border: 1px solid ${({ theme }) => theme.colors.pureWhite};
  border-radius: 30px;
`;

const StyledScrollText = styled.span`
  color: ${({ theme }) => theme.colors.pureWhite};
  font-size: ${({ theme }) => theme.pixelToRem(14)};
  font-weight: 300;
  padding-left: 2px;
`;

const StyledScrollCircle = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  width: 8px;
  height: 8px;
  border-radius: 50px;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  animation: ${handleScrollAnimation} 1700ms cubic-bezier(0, 0, 0.2, 1) infinite;
  transform: translate(-50%, -50%);
`;
